module.exports = __webpack_public_path__ + "img/aurora.ac70f7c.png";